import createStore from 'zustand/vanilla';
import createHook from 'zustand';

const initial = {
  isPlayerLoaded: false,
  currentClassData: {},
  isClassPage: false
};

const getHandlers = (set) => ({
  setPlayerLoaded: (value = false) =>
    set((state) => ({
      ...state,
      isPlayerLoaded: value
    })),
  setCurrentClassData: (data) =>
    set((state) => ({
      ...state,
      currentClassData: data
    })),
  setIsClassPage: (flag = false) =>
    set((state) => ({
      ...state,
      isClassPage: flag
    }))
});

const store = createStore((set) => ({
  ...initial,
  ...getHandlers(set)
}));

const useStore = createHook(store);

const usePlayerStore = () => {
  const currentClassData = useStore((state) => state.currentClassData);
  const isPlayerLoaded = useStore((state) => state.isPlayerLoaded);
  const isClassPage = useStore((state) => state.isClassPage);

  const setCurrentClassData = useStore((state) => state.setCurrentClassData);
  const setPlayerLoaded = useStore((state) => state.setPlayerLoaded);
  const setIsClassPage = useStore((state) => state.setIsClassPage);

  return {
    isPlayerLoaded,
    currentClassData,
    setCurrentClassData,
    setPlayerLoaded,
    setIsClassPage,
    isClassPage
  };
};

export default usePlayerStore;
